const appcolors = {
  primary: "#EA580C",
  primaryLight: "#FDEEE6",
  authGradient: "linear-gradient(46.79deg, #EA580C 0%, #000000 68.04%)",
  white: "#ffffff",
  black: "#000000",
  softGrey: "#D6D6D7",
  slateGrey: "#8692A6",
  darkGrey: "#525252",
  charcolGrey: "#696F79",
  lightGrey: "#ADADAD",
  gunmetal: "#343A40",
  crayolaGrey: "#868E96",
  emeraldGreen: "#46C85C",
  indianRed: "#D45151",
  pictonBlue: "#40B6E9",
  tumbleweed: "#EA9366",
  caribbeanGreen: "#04C982",
  redOrange: "#FF1F1F",
  red: "#FF0000",
};

export default appcolors;
